package ui.resource.icons

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.vector.*
import api.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import org.jetbrains.compose.resources.*
import org.ssoft.common.server.icons.IconIO
import provider.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.*
import ui.widget.*


interface IconsListingScope {
    val vm: IconsListingVM
    val nav:Navigation
    val action: (IconsListingVM.Action) -> Unit
    val display: CommonDisplayProvider

    companion object {

        @Composable
        fun rememberScope(): IconsListingScope {
            val display = LocalDisplayProvider.current
            val nav = LocalNavigation.current
            val vm = nav.viewModel(IconsListingVM::class)

            val action = IconsListingVM.Action.rememberAction(vm)

            return remember {
                object : IconsListingScope {
                    override val vm: IconsListingVM
                        get() = vm
                    override val nav: Navigation
                        get() = nav
                    override val action: (IconsListingVM.Action) -> Unit
                        get() = action
                    override val display: CommonDisplayProvider
                        get() = display
                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        result: IconIO.Result,
    ) : EFieldList<IconIO.Result.Item, Wrapper.Item>(
        items = result.items,
        onBindEntry = { Item(it) }
    ) {

        class Item(
            override val data: IconIO.Result.Item,
            override val key: String = data.id.toString(),
        ) : Entry<IconIO.Result.Item>
    }

}
